import { patientApi } from "@mgdx/api/lib/patientApi";
import { Patient } from "@mgdx/shared/src/models/Patient";
import { getApiError } from "@mgdx-libs/error-handler";
import { getAuthedFirebaseUserToken, getFirebaseAuth, setAccessToken } from "@mgdx-libs/firebase";
import { User } from "firebase/auth";

import { setCurrentUser } from "../../stores/currentUserStore";

/**
 * 待機中にサインアウトや別の患者への切り替えが起きた場合は、古い患者のトークンと患者情報を書き込まずに undefined を返す
 */
export const getPatientFromFirebaseUserAndSetToStorage = async (firebaseUser: User): Promise<Patient | undefined> => {
  const result = await getAuthedFirebaseUserToken(firebaseUser).catch((tokenError: Error) => {
    throw tokenError;
  });

  if (getFirebaseAuth().currentUser?.uid !== firebaseUser.uid) return undefined;
  setAccessToken(result.token);

  const patient = await patientApi.getCurrentPatient().catch(async (errorOrResponse) => {
    throw await getApiError(errorOrResponse);
  });

  if (getFirebaseAuth().currentUser?.uid !== firebaseUser.uid) return undefined;
  setCurrentUser(patient);

  return patient;
};
